import React from "react";
import moment from "moment";
import { IMAGE_BASE_URL } from "../../config/api";
import { checkUrl } from "../../shared/string";

// ticket_action.action_name -> label + badge tone
const STATUS = {
    "OPEN": { label: "Registered", tone: "grey" },
    "ASSIGN": { label: "Open", tone: "blue" },
    "ACTION TAKEN": { label: "Action taken", tone: "green" },
    "CLOSED": { label: "Closed", tone: "grey" },
    "REOPEN": { label: "Reopened", tone: "amber" },
    "ESCALATE": { label: "Escalated", tone: "red" },
    "UPDATE": { label: "Updated", tone: "blue" },
};

export const statusMeta = (actionName) =>
    STATUS[String(actionName || "").toUpperCase()] || { label: actionName || "—", tone: "grey" };

export const StatusBadge = ({ actionName }) => {
    const { label, tone } = statusMeta(actionName);
    return <span className={`ofc-badge ofc-badge--${tone}`}>{label}</span>;
};

/** Only complaints still waiting on the officer have a running clock. */
const PENDING = ["ASSIGN", "REOPEN", "ESCALATE", "OPEN", "UPDATE"];

export const isPending = (actionName) => PENDING.includes(String(actionName || "").toUpperCase());

/**
 * action_time_remaining is a MySQL TIME ("HH:MM:SS", negative once overdue).
 * MySQL caps TIME at ±838:59:59, so every long-overdue complaint reads
 * "-838:59:59" — we show "Overdue" instead of that meaningless number.
 */
export const slaInfo = (actionTimeRemaining, actionName) => {
    if (!isPending(actionName) || !actionTimeRemaining) return null;
    const raw = String(actionTimeRemaining);
    if (raw.startsWith("-")) return { label: "Overdue", tone: "red" };
    const [h = 0, m = 0] = raw.split(":").map(Number);
    if (h >= 24) return { label: `${Math.floor(h / 24)}d ${h % 24}h left`, tone: "grey" };
    return { label: h > 0 ? `${h}h ${m}m left` : `${m}m left`, tone: h < 12 ? "amber" : "grey" };
};

export const fmtDate = (d) => (d ? moment(d).format("DD MMM YYYY") : "—");
export const fmtDateTime = (d) => (d ? moment(d).format("DD MMM YYYY, hh:mm A") : "—");

export const fileUrl = (path) =>
    !path ? null : checkUrl(path) ? path : `${IMAGE_BASE_URL}/${String(path).replace(/^\/+/, "")}`;

/** The complainant's identity is only shown when they agreed to share it. */
export const canShowComplainant = (t) => t?.shareNumber === "YES";

export const categoryText = (t) =>
    [t?.category, t?.categoryType, t?.categorySubType].map((s) => String(s || "").trim()).filter(Boolean).join(" › ");
